export function formatCopilotWorkSummaryText(summary: string) {
  const formattedSummary = summary.replace(/^[A-Z](?=[a-z]*(?:\s|$))/, firstLetter => firstLetter.toLowerCase())
  return `started work to ${formattedSummary}`
}
